// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.attribtable-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
}

div.attribtable-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 2.75em;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(200, 200, 200, 0.9);
    z-index: 2;
}

div.attribtable-overlay > div.spinner {
    width: 4em;
    height: 4em;
    margin-right: 1em;
}

div.dock-window > div.resizeable-window-body > div.attribtable-body {
    /* titlebar: 2.5em, padding: 0.5em */
    max-height: calc(100vh - 2.5em - 0.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - titlebar - window_padding - topbar - bottombar*/
    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - 0.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - titlebar - window_padding - topbar - bottombar*/
}

div.attribtable-toolbar {
    display: flex;
    align-items: center;
    padding: 0.25em;
    flex: 0 0 auto;
}

div.attribtable-toolbar > * {
    margin: 0.125em;
}

div.attribtable-toolbar > select {
    border: 1px solid var(--border-color);
    height: 2em;
}

div.attribtable-contents {
    flex: 1 1 auto;
    background-color: var(--list-bg-color);
    overflow: auto;
    border: 1px solid var(--border-color);
}

table.attribtable-table {
    min-width: 100%;
}

table.attribtable-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 0;
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    box-shadow: inset -1px 0 0 var(--border-color),
                inset 0 -1px 0 var(--border-color);
}

table.attribtable-table th:first-child {
    position: sticky;
    left: 0;
    z-index: 2;
}

table.attribtable-table th > span {
    margin: 0 0 -1px -1px;
    padding: 0.25em;
    display: flex;
    align-items: center;
    position: relative;
}

span.attribtable-table-headername {
    flex: 1 1 auto;
    text-align: left;
}

table.attribtable-table th > span > span.icon {
    flex: 0 0 auto;
    margin-left: 0.5em;
}

table.attribtable-table tr:nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

table.attribtable-table tr:hover:not(.row-disabled) {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

table.attribtable-table td:first-child {
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    align-items: center;
    padding: 0.25em 0.5em;
    background-clip: padding-box;
    position: sticky;
    left: 0;
    z-index: 1;
    width: 2.5em;
}

table.attribtable-table td:first-child::after {
    position: absolute;
    right: -1px;
    top: 0;
    bottom: 0;
    border-right: 1px solid var(--border-color);
    content: '';
}

span.attribtable-table-ldraghandle,
span.attribtable-table-rdraghandle {
    display: block;
    position: absolute;
    width: 4px;
    top: 0;
    bottom: 0;
    cursor: ew-resize;
}

span.attribtable-table-ldraghandle {
    left: -1px;
}

span.attribtable-table-rdraghandle {
    right: 0px;
}

span.attribtable-table-tdraghandle,
span.attribtable-table-bdraghandle {
    display: block;
    position: absolute;
    height: 4px;
    left: 0;
    right: 0;
    cursor: ns-resize;
}

span.attribtable-table-tdraghandle {
    top: -1px;
}

span.attribtable-table-bdraghandle {
    bottom: 0px;
}

table.attribtable-table {
    table-layout: fixed;
}

table.attribtable-table td {
    border: 1px solid var(--border-color);
    text-align: center;
    vertical-align: center;
    position: relative;
}

table.attribtable-table td > input:not([type=checkbox]),
table.attribtable-table td > select,
table.attribtable-table td pre.text-input,
table.attribtable-table td > span.edit-upload-field {
    width: 100%;
    min-width: 4em;
    border: none!important;
    background-color: transparent!important;
    margin: 0;
}

table.attribtable-table td > div.TextInput,
table.attribtable-table td > div.TextInput > pre {
    min-height: 2em;
}

table.attribtable-table td > *:disabled,
table.attribtable-table tr.row-disabled,
table.attribtable-table tr.row-disabled * {
    color: var(--text-color-disabled);
    cursor: not-allowed!important;
}

div.attribtable-footbar {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
}

div.attribtable-footbar > div {
    margin: 0.25em;
}

div.attribtable-footbar > div.navbar {
    flex: 0 0 auto;
}

div.attribtable-filter {
    display: inline-flex;
    align-items: center;
    flex: 1 1 auto;
}

div.attribtable-filter input {
    flex: 1 1 auto;
    width: 0;
}

body.ewresizing, body.ewresizing * {
    cursor: ew-resize!important;
}

body.nsresizing, body.nsresizing * {
    cursor: ns-resize!important;
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/AttributeTable.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,wFAAwF,EAAE,6DAA6D;IACvJ,uGAAuG,EAAE,6DAA6D;AAC1K;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,cAAc;IACd,sCAAsC;IACtC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,UAAU;IACV,wCAAwC;IACxC,+BAA+B;IAC/B;kDAC8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,mBAAmB;IACnB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,2CAA2C;IAC3C,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;;;IAII,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,uCAAuC;IACvC,SAAS;AACb;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;IAGI,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["div.attribtable-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    position: relative;\r\n}\r\n\r\ndiv.attribtable-overlay {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 2.75em;\r\n    bottom: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(200, 200, 200, 0.9);\r\n    z-index: 2;\r\n}\r\n\r\ndiv.attribtable-overlay > div.spinner {\r\n    width: 4em;\r\n    height: 4em;\r\n    margin-right: 1em;\r\n}\r\n\r\ndiv.dock-window > div.resizeable-window-body > div.attribtable-body {\r\n    /* titlebar: 2.5em, padding: 0.5em */\r\n    max-height: calc(100vh - 2.5em - 0.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - titlebar - window_padding - topbar - bottombar*/\r\n    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - 0.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - titlebar - window_padding - topbar - bottombar*/\r\n}\r\n\r\ndiv.attribtable-toolbar {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0.25em;\r\n    flex: 0 0 auto;\r\n}\r\n\r\ndiv.attribtable-toolbar > * {\r\n    margin: 0.125em;\r\n}\r\n\r\ndiv.attribtable-toolbar > select {\r\n    border: 1px solid var(--border-color);\r\n    height: 2em;\r\n}\r\n\r\ndiv.attribtable-contents {\r\n    flex: 1 1 auto;\r\n    background-color: var(--list-bg-color);\r\n    overflow: auto;\r\n    border: 1px solid var(--border-color);\r\n}\r\n\r\ntable.attribtable-table {\r\n    min-width: 100%;\r\n}\r\n\r\ntable.attribtable-table th {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1;\r\n    padding: 0;\r\n    background-color: var(--button-bg-color);\r\n    color: var(--button-text-color);\r\n    box-shadow: inset -1px 0 0 var(--border-color),\r\n                inset 0 -1px 0 var(--border-color);\r\n}\r\n\r\ntable.attribtable-table th:first-child {\r\n    position: sticky;\r\n    left: 0;\r\n    z-index: 2;\r\n}\r\n\r\ntable.attribtable-table th > span {\r\n    margin: 0 0 -1px -1px;\r\n    padding: 0.25em;\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n}\r\n\r\nspan.attribtable-table-headername {\r\n    flex: 1 1 auto;\r\n    text-align: left;\r\n}\r\n\r\ntable.attribtable-table th > span > span.icon {\r\n    flex: 0 0 auto;\r\n    margin-left: 0.5em;\r\n}\r\n\r\ntable.attribtable-table tr:nth-child(even) {\r\n    background-color: var(--list-item-bg-color-even);\r\n}\r\n\r\ntable.attribtable-table tr:hover:not(.row-disabled) {\r\n    background-color: var(--list-item-bg-color-hover);\r\n    color: var(--list-item-text-color-hover);\r\n}\r\n\r\ntable.attribtable-table td:first-child {\r\n    background-color: var(--button-bg-color);\r\n    color: var(--button-text-color);\r\n    align-items: center;\r\n    padding: 0.25em 0.5em;\r\n    background-clip: padding-box;\r\n    position: sticky;\r\n    left: 0;\r\n    z-index: 1;\r\n    width: 2.5em;\r\n}\r\n\r\ntable.attribtable-table td:first-child::after {\r\n    position: absolute;\r\n    right: -1px;\r\n    top: 0;\r\n    bottom: 0;\r\n    border-right: 1px solid var(--border-color);\r\n    content: '';\r\n}\r\n\r\nspan.attribtable-table-ldraghandle,\r\nspan.attribtable-table-rdraghandle {\r\n    display: block;\r\n    position: absolute;\r\n    width: 4px;\r\n    top: 0;\r\n    bottom: 0;\r\n    cursor: ew-resize;\r\n}\r\n\r\nspan.attribtable-table-ldraghandle {\r\n    left: -1px;\r\n}\r\n\r\nspan.attribtable-table-rdraghandle {\r\n    right: 0px;\r\n}\r\n\r\nspan.attribtable-table-tdraghandle,\r\nspan.attribtable-table-bdraghandle {\r\n    display: block;\r\n    position: absolute;\r\n    height: 4px;\r\n    left: 0;\r\n    right: 0;\r\n    cursor: ns-resize;\r\n}\r\n\r\nspan.attribtable-table-tdraghandle {\r\n    top: -1px;\r\n}\r\n\r\nspan.attribtable-table-bdraghandle {\r\n    bottom: 0px;\r\n}\r\n\r\ntable.attribtable-table {\r\n    table-layout: fixed;\r\n}\r\n\r\ntable.attribtable-table td {\r\n    border: 1px solid var(--border-color);\r\n    text-align: center;\r\n    vertical-align: center;\r\n    position: relative;\r\n}\r\n\r\ntable.attribtable-table td > input:not([type=checkbox]),\r\ntable.attribtable-table td > select,\r\ntable.attribtable-table td pre.text-input,\r\ntable.attribtable-table td > span.edit-upload-field {\r\n    width: 100%;\r\n    min-width: 4em;\r\n    border: none!important;\r\n    background-color: transparent!important;\r\n    margin: 0;\r\n}\r\n\r\ntable.attribtable-table td > div.TextInput,\r\ntable.attribtable-table td > div.TextInput > pre {\r\n    min-height: 2em;\r\n}\r\n\r\ntable.attribtable-table td > *:disabled,\r\ntable.attribtable-table tr.row-disabled,\r\ntable.attribtable-table tr.row-disabled * {\r\n    color: var(--text-color-disabled);\r\n    cursor: not-allowed!important;\r\n}\r\n\r\ndiv.attribtable-footbar {\r\n    flex: 0 0 auto;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\ndiv.attribtable-footbar > div {\r\n    margin: 0.25em;\r\n}\r\n\r\ndiv.attribtable-footbar > div.navbar {\r\n    flex: 0 0 auto;\r\n}\r\n\r\ndiv.attribtable-filter {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    flex: 1 1 auto;\r\n}\r\n\r\ndiv.attribtable-filter input {\r\n    flex: 1 1 auto;\r\n    width: 0;\r\n}\r\n\r\nbody.ewresizing, body.ewresizing * {\r\n    cursor: ew-resize!important;\r\n}\r\n\r\nbody.nsresizing, body.nsresizing * {\r\n    cursor: ns-resize!important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
